import { render } from "./Pagination3.vue?vue&type=template&id=19f162f3"
import script from "./Pagination3.vue?vue&type=script&lang=js"
export * from "./Pagination3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__